export const QA_NAME_CUSTOMIZE_RECIPIENT_MODAL = 'recipients'

export const RECIPIENT_AUDIENCE_INFO_NOTIFICATION = 'infoMessage'
